/** Base path for guide pages. Change here to update all guide links site-wide. */
export const GUIDE_ROUTE_PREFIX = '/guides';

export function getGuidePath(slug: string): string {
  return `${GUIDE_ROUTE_PREFIX}/${slug}`;
}
